<script setup lang="ts">
import { CheckCircle2, History } from 'lucide-vue-next';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card';
import { Table, TableHeader, TableBody, TableRow, TableHead } from '@/components/ui/table';
import MovementTable from '../MovementTable.vue';

defineProps<{
    realizedGroups: any[];
    futureGroups: any[];
    isAmountsHidden: boolean;
}>();

defineEmits(['edit', 'duplicate', 'delete', 'delete-import', 'validate']);
</script>

<template>
    <div class="space-y-8">
        <!-- Realized movements table -->
        <Card class="border-border shadow-sm overflow-hidden">
            <CardHeader class="flex flex-row items-center justify-between border-b border-border bg-muted/30">
                <div class="flex items-center gap-3">
                    <div class="p-2 bg-emerald-500/10 text-emerald-500 rounded-lg border border-emerald-500/20">
                        <CheckCircle2 class="w-5 h-5" />
                    </div>
                    <div>
                        <CardTitle class="text-lg text-foreground">Mouvements Réalisés</CardTitle>
                        <CardDescription>Historique complet des opérations validées.</CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent class="p-0">
                <Table>
                    <TableHeader>
                        <TableRow class="bg-muted/30 hover:bg-muted/30 border-border">
                            <TableHead class="w-[50px]"></TableHead>
                            <TableHead class="font-bold text-foreground">Date</TableHead>
                            <TableHead class="font-bold text-foreground">Type</TableHead>
                            <TableHead class="font-bold text-foreground">Catégorie globale</TableHead>
                            <TableHead class="font-bold text-right text-foreground">Montant Total</TableHead>
                            <TableHead class="text-right font-bold pr-6 text-foreground">Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <MovementTable
                            :groups="realizedGroups"
                            table-type="realized"
                            :is-amounts-hidden="isAmountsHidden"
                            @edit="$emit('edit', $event)"
                            @duplicate="$emit('duplicate', $event)"
                            @delete="$emit('delete', $event)"
                            @delete-import="$emit('delete-import', $event)"
                        />
                    </TableBody>
                </Table>
            </CardContent>
        </Card>

        <!-- Future movements table -->
        <Card class="border-border shadow-sm overflow-hidden">
            <CardHeader class="flex flex-row items-center justify-between border-b border-border bg-muted/30">
                <div class="flex items-center gap-3">
                    <div class="p-2 bg-blue-500/10 text-blue-500 rounded-lg border border-blue-500/20">
                        <History class="w-5 h-5" />
                    </div>
                    <div>
                        <CardTitle class="text-lg text-foreground">Mouvements Futurs (Prévisionnels)</CardTitle>
                        <CardDescription>Opérations planifiées ou projections à venir.</CardDescription>
                    </div>
                </div>
            </CardHeader>
            <CardContent class="p-0">
                <Table>
                    <TableHeader>
                        <TableRow class="bg-muted/30 hover:bg-muted/30 border-border">
                            <TableHead class="w-[50px]"></TableHead>
                            <TableHead class="font-bold text-foreground">Date</TableHead>
                            <TableHead class="font-bold text-foreground">Type</TableHead>
                            <TableHead class="font-bold text-foreground">Catégorie globale</TableHead>
                            <TableHead class="font-bold text-right text-foreground">Montant Total</TableHead>
                            <TableHead class="text-right font-bold pr-6 text-foreground">Actions</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <MovementTable
                            :groups="futureGroups"
                            table-type="future"
                            :is-amounts-hidden="isAmountsHidden"
                            @validate="$emit('validate', $event)"
                            @edit="$emit('edit', $event)"
                            @duplicate="$emit('duplicate', $event)"
                            @delete="$emit('delete', $event)"
                            @delete-import="$emit('delete-import', $event)"
                        />
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    </div>
</template>
